import Spacer from '@/common/components/spacer';
import QuoteBubble from '@/icons/quote-bubble';

interface TestimonialNameProps {
  name: string;
}

export default function TestimonialName({ name }: TestimonialNameProps) {
  return (
    <div className="flex flex-row items-center">
      <QuoteBubble />
      <Spacer variant="width8" />

      <p className="text-uppercase body3-strong">{name}</p>
    </div>
  );
}
